import { render, staticRenderFns } from "./PurchaseProfileData.vue?vue&type=template&id=01e8f9b6&scoped=true&"
import script from "./PurchaseProfileData.vue?vue&type=script&lang=js&"
export * from "./PurchaseProfileData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8f9b6",
  null
  
)

export default component.exports